/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Logger, green } from "cms/utils/log/logger";
import {
    setCategories,
    setComponentConfigs,
    setByCategory,
    setComponentConfigsAll
} from "./component.slice";
import { dispatch } from "data/store";

export const fetchComponentCategories = createAsyncThunk(
    "component/category/fetch",
    
    /**
     * @param {object} arg
     * @param {string} arg.token
     */
    async function (arg) {
        const { token } = arg;
        Logger.info(green("Loading Component Configs..."));
        const response = await SimpliCityAdminSDK.componentConfig.findCategoryList(token);
        dispatch(setCategories(response));
        return response;
    }
);

export const fetchComponentConfigs = createAsyncThunk(
    "component/config/fetch",

    /**
     * @param {object} arg
     * @param {string} arg.token
     */
    async function (arg) {
        const { token } = arg;
        Logger.info(green("Loading Component Configs..."));
        const response = await SimpliCityAdminSDK.componentConfig.find(token);
        dispatch(setComponentConfigs(response));
        return response;
    }
);

export const fetchComponentConfigsByCategory = createAsyncThunk(
    "component/category/config/fetch",

    /**
     * @param {object} arg
     * @param {string} arg.token
     * @param {string} arg.category
     */
    async function (arg) {
        const { token, category } = arg;
        Logger.info(green("Loading Component Configs by Category..."));
        const response = await SimpliCityAdminSDK.componentConfig.findByCategory(token, category);
        dispatch(setByCategory(response));
        return response;
    }
);

export const fetchAllComponentConfigsByCategory = createAsyncThunk(
    "component/category/config/all/fetch",

    /**
     * @param {object} arg
     * @param {string} arg.token
     */
    async function (arg) {
        const { token } = arg;
        Logger.info(green("Loading All Component Configs by Category..."));
        const response = await SimpliCityAdminSDK.componentConfig.findAll(token);
        dispatch(setComponentConfigsAll(response));
        return response;
    }
);
export const fetchOneComponentConfig = createAsyncThunk(
    "component/config/type/fetch",

    /**
     * @param {object} arg
     * @param {string} arg.token
     * @param {string} arg.type
     */
    async function (arg) {
        const { token, type } = arg;
        Logger.info(green("Loading One Component Config by Type..."));
        const response = await SimpliCityAdminSDK.componentConfig.findByType(token, type);
        return response;
    }
);
